import React from "react";

interface CommonbadgeProps {
  status: string;
  className?: string;
  style?: React.CSSProperties;
}

const Commonbadge: React.FC<CommonbadgeProps> = ({
  status,
  className = "",
  style = {},
}) => {
  const normalizedStatus = (status || "").trim().toLowerCase();

  let bgColor = "#f1f5f9";
  let textColor = "#475569";

  if (
    normalizedStatus === "active" ||
    normalizedStatus === "ongoing" ||
    normalizedStatus === "available" ||
    normalizedStatus === "passed" ||
    normalizedStatus === "pass" ||
    normalizedStatus === "verified" ||
    normalizedStatus === "activities completed" ||
    normalizedStatus === "completed"
  ) {
    bgColor = "#d1fae5";
    textColor = "#065f46";
  } else if (

    normalizedStatus === "transferred" || normalizedStatus === "assigned" ||
    normalizedStatus === "checked out"
  ) {
    bgColor = "#e0f2fe";
    textColor = "#0369a1";
  } else if (
    normalizedStatus === "closed" ||
    normalizedStatus === "inactive" ||
    normalizedStatus === "draft" ||
    normalizedStatus === "scheduled" ||
    normalizedStatus === "enrolled"

  ) {
    bgColor = "#c9e1fa";
    textColor = "#475569";
  } else if (
    normalizedStatus === "paused" ||
    normalizedStatus === "temporary blocked" ||
    normalizedStatus === "started" ||
    normalizedStatus === "in progress" ||
    normalizedStatus === "checked in"
  ) {
    bgColor = "#fef3c7";
    textColor = "#d97706";
  }
  else if (normalizedStatus === "eligible") {
    bgColor = "#e2d9f8";
    textColor = "#5118d6";
  }
  else if (
    normalizedStatus === "attention" ||
    normalizedStatus === "danger" ||
    normalizedStatus === "failed" ||
    normalizedStatus === "fail" ||
    normalizedStatus === "dropout" ||
    normalizedStatus === "permanent blocked" ||
    normalizedStatus === "blocked" ||
    normalizedStatus === "dropped"
  ) {
    bgColor = "#fef2f2";
    textColor = "#dc2626";
  }

  const badgeStyle: React.CSSProperties = {
    display: "inline-block",
  whiteSpace: "nowrap",  
    fontSize: "0.6875rem", // 11px
    fontWeight: 700,
    padding: "0.1875rem 0.5rem", // 3px 8px to align with mockup height
    borderRadius: "20px", // 4px rounded corner matching mockup
    backgroundColor: bgColor,
    color: textColor,
    textAlign: "center",
    ...style,
  };

  const formatStatus = (str: string) => {
    if (!str) return "";
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  return (
    <span className={className} style={badgeStyle}>
      {formatStatus(status)}
    </span>
  );
};

export default Commonbadge;
